import React, { useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Pagination from "../Components/Pagination";
import { Link } from "react-router-dom";

const VideoGallery = () => {
  // ---------- Video Data ----------
  const videos = [
    // Page 1
    {
      id: 1,
      src: "https://www.youtube.com/embed/3892OVYLm2M?si=29JGqeb3nGKFKipB",
      title: "A Short Description on Vikash's Projects",
    },
    {
      id: 2,
      src: "https://www.youtube.com/embed/EYkWdD-tydM?si=pxBEDHsCz45Jr8S0",
      title: "Vikash",
    },
    {
      id: 3,
      src: "https://www.youtube.com/embed/8Vn1ob_xBVY?si=4F6R9dDtDxLgmh2b",
      title: "PANCHAGNAG SCHOOL",
    },
    {
      id: 4,
      src: "https://www.youtube.com/embed/nUZ-teUZSKw?si=Kj5KHh585rMQBxqD",
      title: "Ring the Bell Motari School",
    },
    {
      id: 5,
      src: "https://www.youtube.com/embed/X3l_czXyW7o?si=NQuHd8HQQUqg2JUz",
      title: "PANCHAGNAG SCHOOL 2",
    },
    {
      id: 6,
      src: "https://www.youtube.com/embed/1wVh-anEtYo?si=C2B7CX_InDNq-H5B",
      title: "VILLAGE DEVELOPMENT COMMITTEE FORMATION",
    },
    // Page 2
    {
      id: 7,
      src: "https://www.youtube.com/embed/0h3miLRYLJY?si=1LIQgC39Gc24riub",
      title: "Appeal for Rosy",
    },
    {
      id: 8,
      src: "https://www.youtube.com/embed/qxUGrj_9w0Y?si=_UV1rTi27Iz6pDbi",
      title: "ପଟାଙ୍ଗୀରେଆନ୍ତଜାତିକ ଭିନ୍ନକ୍ଷମ ଦିବସପାଳିତ!! BE NEWS !!",
    },
    {
      id: 9,
      src: "https://www.youtube.com/embed/RiKkGtL0JmQ?si=adJwQIYD9TIXROvT",
      title: "Empowering Communities",
    },
    {
      id: 10,
      src: "https://www.youtube.com/embed/PoQp8NrwFXw?si=U0wtPXbOaNQk9alJ",
      title: "ଆନ୍ତର୍ଜାତିକ ଭିନ୍ନକ୍ଷମ ଦିବସ ପାଳିତ ",
    },
    
    // Page 3
    
  ];

  // ---------- Pagination Logic ----------
  const [currentPage, setCurrentPage] = useState(1);
  const videosPerPage = 6;

  const indexOfLastVideo = currentPage * videosPerPage;
  const indexOfFirstVideo = indexOfLastVideo - videosPerPage;
  const currentVideos = videos.slice(indexOfFirstVideo, indexOfLastVideo);
  const totalPages = Math.ceil(videos.length / videosPerPage);

  return (
    <>
      <Header />

      {/* Page Header */}
      <section className="page-header">
        <div
          className="page-header__bg"
          style={{ backgroundImage: "url(assets/images/backgrounds/VG.jpg)" }}
        ></div>
        <div className="shape1 float-bob-x">
          <img src="assets/images/shapes/page-header-shape1.png" alt=""
          style={{ filter: 'hue-rotate(90deg)' }}
          
          />
        </div>
        <div className="shape2">
          <img src="assets/images/shapes/page-header-shape2.png" alt=""
          
           style={{ filter: 'hue-rotate(90deg)' }}/>
        </div>
        <div className="container">
          <div className="page-header__inner">
            <h2 className="wow fadeInDown" data-wow-duration="1500ms">
              Video Gallery
            </h2>
          </div>
        </div>
      </section>
                                        
      {/* Video Gallery Section */}
      <section className="py-5 bg-white">
        <div className="container">
      
          {/* <div className="bg-success text-white text-center p-5 rounded">
            <h1 className="fw-bold">Video Gallery</h1>
            <p className="mt-2 fs-5">
              Visit Vikash's video gallery to witness our journey, stories of
              impact, and community transformation through our initiatives.
            </p>
            <button className="btn btn-warning fw-semibold text-dark mt-3">
              Donation
            </button>
          </div> */}

          {/* Video Grid */}
          <div className="row mt-5">
            {currentVideos.map((video) => (
              <div className="col-md-6 col-lg-4 mb-4" key={video.id}>
                <div className="card video-card border-0 shadow">
                  <iframe
                    className="card-img-top"
                    height="200"
                    src={video.src}
                    title={video.title}
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="card-body">
                    <p className="card-text fw-semibold">{video.title}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination Component */}
          <Pagination
            totalPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </section>

      <Footer />

      {/* Scroll to Top */}
      <a href="#" data-target="html" className="scroll-to-target scroll-to-top">
        <span className="scroll-to-top__wrapper">
          <span className="scroll-to-top__inner" />
        </span>
        <span className="scroll-to-top__text">Go Back Top</span>
      </a>
    </>
  );
};

export default VideoGallery;
